import {
	dark as darkTheme,
	light as lightTheme,
	shape as shapeTheme,
	spacing as spacingTheme,
	typography as typographyTheme,
} from '@atlaskit/tokens/tokens-raw';

import type { TransformedTokenMerged, TransformedTokenWithAttributes } from './types';

const lightDarkTokens = lightTheme.map((lightToken) => {
	const darkToken = darkTheme.find((token) => token.name === lightToken.name);
	const mergedToken = {
		...lightToken,
		darkToken: (darkToken as TransformedTokenWithAttributes)!,
	} as TransformedTokenMerged;

	return mergedToken;
});

const typographyThemeFiltered = typographyTheme.filter(
	(token) => token.cleanName !== 'font.body.UNSAFE_small',
);

const newShapeTokens = shapeTheme.filter((token) => !token.attributes.deprecated);

const mergedTokens: TransformedTokenMerged[] = lightDarkTokens.concat(
	// @ts-expect-error this is annoying and related to the tokens defintions
	...spacingTheme,
	...typographyThemeFiltered,
	...newShapeTokens,
);

export default mergedTokens;
